"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonIcon = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var react_1 = __importDefault(require("react"));
var paragraphy_styles_1 = require("../../token/paragraphy/paragraphy.styles");
var styles_1 = require("./styles");
var ButtonIcon = function (_a) {
    var id = _a.id, className = _a.className, icon = _a.icon, withLabel = _a.withLabel, label = _a.label, onClick = _a.onClick, ariaLabel = _a.ariaLabel, titleAccess = _a.titleAccess, primary = _a.primary, secondary = _a.secondary, loading = _a.loading, disabled = _a.disabled, small = _a.small, medium = _a.medium, large = _a.large, props = __rest(_a, ["id", "className", "icon", "withLabel", "label", "onClick", "ariaLabel", "titleAccess", "primary", "secondary", "loading", "disabled", "small", "medium", "large"]);
    var theme = (0, temas_frontend_1.useTheme)().theme;
    return (react_1.default.createElement(styles_1.IconButtonStyled, __assign({ id: id, className: className, "aria-label": ariaLabel, "title-access": titleAccess, small: small, medium: medium, large: large, withLabel: withLabel, primary: primary, secondary: secondary, loading: loading, disabled: disabled, onClick: onClick }, props),
        icon,
        react_1.default.createElement(paragraphy_styles_1.PStyled, { p12: true, bold: true, color: theme.p001, className: "withLabel" }, label)));
};
exports.ButtonIcon = ButtonIcon;
